import React from 'react';
import { ArrowUpRight, Gift } from 'lucide-react';
import { newsCategories, categoryChips } from '../mock';
import Reveal from './Reveal';

const NewsCategories = () => {
  return (
    <section id="news" className="py-24 relative">
      <div className="container-ydd">
        <Reveal>
          <div className="max-w-2xl">
            <span className="text-[var(--ydd-yellow)] font-semibold text-sm uppercase tracking-widest">Stay Updated</span>
            <h2 className="font-display text-white text-3xl md:text-5xl mt-4 leading-tight">News across every category</h2>
            <p className="text-gray-400 mt-4 text-lg">From breaking headlines to cricket, business, tech and entertainment — quick, reliable updates to keep you ahead of the curve.</p>
          </div>
        </Reveal>

        {/* category chips */}
        <Reveal delay={80}>
          <div className="flex flex-wrap gap-2.5 mt-10">
            {categoryChips.map((c) => {
              const Icon = c.icon;
              return (
                <button key={c.label} className="group flex items-center gap-2 rounded-full border border-white/10 bg-[#16161B] px-4 py-2 text-sm text-gray-300 hover:border-[var(--ydd-yellow)] hover:text-[var(--ydd-yellow)] transition-colors duration-200">
                  <Icon size={15} /> {c.label}
                </button>
              );
            })}
          </div>
        </Reveal>

        {/* news cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {newsCategories.map((n, i) => (
            <Reveal key={i} delay={(i % 3) * 90}>
              <article className="card-ydd overflow-hidden h-full flex flex-col group cursor-pointer">
                <div className="relative h-48 overflow-hidden">
                  <img src={n.img} alt={n.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1B1B21] to-transparent" />
                  <span className="absolute top-3 left-3 bg-[var(--ydd-yellow)] text-[#0E0E11] text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wide">{n.tag}</span>
                  <span className="absolute top-3 right-3 bg-black/60 backdrop-blur text-white text-[11px] font-semibold px-2.5 py-1 rounded-full flex items-center gap-1">
                    <Gift size={12} className="text-[var(--ydd-yellow)]" /> +{n.points}
                  </span>
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <h3 className="text-white font-bold text-lg leading-snug group-hover:text-[var(--ydd-yellow)] transition-colors">{n.title}</h3>
                  <p className="text-gray-400 text-sm mt-2.5 leading-relaxed flex-1">{n.summary}</p>
                  <div className="mt-4 flex items-center gap-1.5 text-sm text-[var(--ydd-yellow)] font-semibold">
                    Read story <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsCategories;
